import React from 'react';
import { Mail, MessageSquare, HelpCircle, Users } from 'lucide-react'; // Optional icons

const ContactUs = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-900 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        {/* Heading - H1 is crucial for SEO */}
        <h1 className="text-4xl sm:text-5xl font-extrabold text-center mb-8 sm:mb-12 text-gray-900 dark:text-white">
          Contact <span className="text-blue-600 dark:text-blue-400">TabDivider</span> Support & Feedback
        </h1>

        <div className="bg-white dark:bg-gray-800 shadow-xl rounded-lg p-6 sm:p-8 lg:p-10 space-y-10">
          {/* Introduction */}
          <section className="text-center">
            <p className="text-lg sm:text-xl leading-relaxed text-gray-700 dark:text-gray-300">
              We're here to help! Whether you have a question about using TabDivider, need support with our <strong>bill splitting app</strong>, want to provide feedback, or simply want to say hello, we'd love to hear from you.
            </p>
          </section>

          {/* Main Contact Method: Email */}
          <section className="text-center">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 dark:text-gray-100 mb-4 flex items-center justify-center">
              <Mail className="h-7 w-7 mr-3 text-blue-600 dark:text-blue-400" />
              Email Us
            </h2>
            <p className="text-lg sm:text-xl leading-relaxed text-gray-700 dark:text-gray-300 mb-3">
              For general inquiries, feature requests, or technical support with TabDivider, please email us at:
            </p>
            <a
              href="mailto:support@tabdivider.com" // Replace with your actual support email
              className="text-xl sm:text-2xl font-medium text-blue-600 dark:text-blue-400 hover:underline hover:text-blue-700 dark:hover:text-blue-300 break-all"
            >
              support@tabdivider.com
            </a>
            <p className="text-md text-gray-600 dark:text-gray-400 mt-4">
              We aim to respond to all inquiries regarding our <strong>expense sharing tool</strong> within 24-48 business hours.
            </p>
          </section>

          {/* Placeholder for Contact Form (if you implement one) */}
          {/*
          <section>
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 dark:text-gray-100 mb-6 text-center flex items-center justify-center">
              <MessageSquare className="h-7 w-7 mr-3 text-green-600 dark:text-green-400" />
              Send Us a Message
            </h2>
            <form className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Full Name</label>
                <input type="text" name="name" id="name" autoComplete="name" className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100" />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Email Address</label>
                <input type="email" name="email" id="email" autoComplete="email" className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100" />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Your Message</label>
                <textarea id="message" name="message" rows="4" className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"></textarea>
              </div>
              <div className="text-center">
                <button type="submit" className="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-lg font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  Send Message
                </button>
              </div>
            </form>
          </section>
          */}

          {/* Other ways to connect / Helpful links */}
          <section>
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 dark:text-gray-100 mb-6 text-center">
              Other Resources
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-center">
              <div className="p-6 bg-gray-100 dark:bg-gray-700/50 rounded-lg">
                <HelpCircle className="h-10 w-10 mx-auto mb-3 text-indigo-600 dark:text-indigo-400" />
                <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
                  Frequently Asked Questions
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-3">
                  Find answers to common questions about TabDivider's features, <strong>bill splitting methods</strong>, and account management.
                </p>
                <a href="/FAQ" className="font-medium text-indigo-600 dark:text-indigo-400 hover:underline">
                  Visit our FAQ Page →
                </a>
              </div>

              <div className="p-6 bg-gray-100 dark:bg-gray-700/50 rounded-lg">
                <Users className="h-10 w-10 mx-auto mb-3 text-teal-600 dark:text-teal-400" />
                <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
                  Community & Social Media
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-3">
                  Connect with other TabDivider users, share tips for <strong>managing shared expenses</strong>, or follow us for updates.
                </p>
                {/* Replace with your actual social media links */}
                <div className="space-x-4">
                  <a href="#" className="font-medium text-teal-600 dark:text-teal-400 hover:underline">Twitter</a>
                  <a href="#" className="font-medium text-teal-600 dark:text-teal-400 hover:underline">Facebook</a>
                </div>
              </div>
            </div>
          </section>

          <section className="text-center pt-6 border-t border-gray-200 dark:border-gray-700">
            <p className="text-md text-gray-600 dark:text-gray-400">
              Your feedback is invaluable in helping us improve TabDivider and make <strong>splitting bills</strong> even easier for everyone. Don't hesitate to get in touch!
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default ContactUs;